var staticParseInt = parseInt

module.exports = staticParseInt



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/static/staticParseInt.js
// module id = 116
// module chunks = 106